import { FC, ReactElement, useState } from "react"
import {
  UpdateChallengeRedeemCodeRequestSchema,
  ChallengesService,
  ChallengeRedeemCode
} from "../sdk"
import { Controller, useForm } from "react-hook-form"
import useError from "../hooks/useError"
import classNames from "classnames"
import Input from "../components/Input"
import Button from "../components/Button"
import Checkbox from "../components/Checkbox"

type Props = {
  onSuccess?(): void
  redeemCode: ChallengeRedeemCode
}

const EditRedeemCodeForm: FC<Props> = ({
  onSuccess,
  redeemCode: {
    id,
    redeemCode,
    challengeId,
    enabled,
    maximumUses
  }
}) => {

  const [loading, setLoading] = useState<boolean>(false)

  const { control, formState, handleSubmit } = useForm<UpdateChallengeRedeemCodeRequestSchema["updates"]>()
  const { handleError } = useError()

  const onSubmit = async({
    redeemCode,
    challengeId,
    enabled,
    maximumUses
  }: UpdateChallengeRedeemCodeRequestSchema["updates"]): Promise<void> => {
    setLoading(true)
    try {
      await ChallengesService.updateChallengeRedeemCode({
        handler: { challengeRedeemCodeId: id },
        updates: {
          redeemCode,
          challengeId: Number(challengeId),
          enabled,
          maximumUses: Number(maximumUses)
        }
      })

      if (onSuccess) {
        onSuccess()
      }
    } catch (err) {
      handleError(err)
    }
    setLoading(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={classNames(loading && "opacity-50 pointer-events-none")}>
      <Controller
        name="redeemCode"
        control={control}
        defaultValue={redeemCode}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Input
              onChange={onChange}
              value={value}
              error={formState.errors.redeemCode?.message}
              label="Redeem Code"
              className="my-3"
            />
          )
        }}
      />

      <Controller
        name="challengeId"
        control={control}
        defaultValue={challengeId}
        rules={{ required: "Campo Obbligatorio" }}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Input
              onChange={onChange}
              value={value}
              error={formState.errors.challengeId?.message}
              label="Challenge ID"
              className="my-3"
            />
          )
        }}
      />

      <Controller
        name="maximumUses"
        control={control}
        defaultValue={maximumUses}
        rules={{ required: "Campo Obbligatorio" }}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Input
              onChange={onChange}
              value={value}
              error={formState.errors.maximumUses?.message}
              label="Numero massimo di utilizzi"
              className="my-3"
            />
          )
        }}
      />

      <Controller
        name="enabled"
        control={control}
        defaultValue={enabled}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Checkbox
              checked={value!}
              label="Abilitato"
              className="ml-4"
              containerClassName="w-56 my-3"
              onChange={onChange}
            />
          )
        }}
      />

      <Button
        type="submit"
        className="w-full"
      >
        Salva
      </Button>
    </form>
  )
}

export default EditRedeemCodeForm